import {useQueries} from "@tanstack/react-query";
import CapturePlacesService from "../../../../../services/web/capture-places-service.js";

const UseFetchOptions = () => {
    const queries = useQueries({
        queries: [
            {
                queryKey: ['capture_places'],
                queryFn: () => CapturePlacesService.options(),
                initialData: []
            }
        ]
    });

    return {
        capturePlacesOptions: queries[0].data
    }
}

export default UseFetchOptions;